<div class="container">
    <div class="row">
        <h4 class="text-uppercase">Payment Successful</h4>
        <p> You'll receive a confirmation email to
            <a class="sg-link" href="mailto:{{email}}">
                {{email}}
            </a> shortly with all your booking and payment details. {{booker.fullName}} will be notified of your payment.
        </p>
        <div class="col-12">
            <div class="d-flex justify-content-center my-4">
                <img src="/ng-assets/checkout/thankyou.svg" alt="Thank You" />
            </div>
        </div>

        <p class="font-weight-medium">
            Please quote your reference number when getting in touch with us.
        </p>

        <div class="reference font-weight-medium">
            Your reference number is:
            <strong>{{
                metadata.ref_no
            }}</strong>
        </div>

        <hr />
    </div>

    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6">
                <h5 class="sg-heading__h5 mb-3">
                    Need any help?
                </h5>

                <ul class="list-unstyled list-green">
                    <li>Call us on 0333 300 3477</li>
                    <li>Write to
                        <a class="sg-link" href="mailto:help@playfinder.com">help@playfinder.com</a
                        >
                    </li>
                    <li *ngIf="authService.user">
                        Check
                        <a
                            class="sg-link"
                            
                            >Your Booking</a
                        >
                        for updates.
                    </li>
                </ul>
            </div>

            <div class="col-12 col-md-6">
                <h5 class="sg-heading__h5 mb-3">
                    Create an account
                </h5>

                <p class="m-0">
                    Download our app and create an account for faster checkout the next time you play.
                </p>
            </div>
        </div>
    </div>
</div>